import React from 'react';
import { HomePage } from './pages/HomePage';
import { RecordsPage } from './pages/RecordsPage';
import { AdvertisingPage } from './pages/AdvertisingPage';
import { SaintLuciaPage } from './pages/SaintLuciaPage';
import { BarndormatoryPage } from './pages/BarndormatoryPage';
import { FilmsPage } from './pages/FilmsPage';
import { ApparelsPage } from './pages/ApparelsPage';
import { HonorableMusicPage } from './pages/HonorableMusicPage';
import { HoneyPage } from './pages/HoneyPage';
import { AnseCanotPage } from './pages/AnseCanotPage';
export function App() {
  const path = window.location.pathname;
  if (path === '/records') {
    return <RecordsPage data-id="element-0" data-mp="31c9w477kb5t1" />;
  }
  if (path === '/advertising') {
    return <AdvertisingPage data-id="element-1" data-mp="2wjgptewg3peu" />;
  }
  if (path === '/saint-lucia') {
    return <SaintLuciaPage data-id="element-2" data-mp="2wi5lndz38fn7" />;
  }
  if (path === '/barndormatory') {
    return <BarndormatoryPage data-id="element-3" data-mp="28sutgkvsztko" />;
  }
  if (path === '/films') {
    return <FilmsPage data-id="element-4" data-mp="23vupcfiil0w7" />;
  }
  if (path === '/apparels') {
    return <ApparelsPage data-id="element-5" data-mp="23t8gmcjw0fce" />;
  }
  if (path === '/honorable-music') {
    return <HonorableMusicPage data-id="element-6" data-mp="3ij668fcdfvai" />;
  }
  if (path === '/honey') {
    return <HoneyPage data-id="element-7" data-mp="3ml14tc2x3ukl" />;
  }
  if (path === '/anse-canot') {
    return <AnseCanotPage data-id="element-8" data-mp="3mjg9hk8s47lo" />;
  }
  return <HomePage data-id="element-9" data-mp="3rcj6y3gog175" />;
}